export enum BackgroundStatusTypes {
  Accepted = 0,
  Processing = 1,
  Succeeded = 10,
  Failed = 11,
  Canceled = 12
}

export function getBackgroundStatusTypeName(value: BackgroundStatusTypes): string {
  switch (value) {
    case BackgroundStatusTypes.Accepted: return '受付済';
    case BackgroundStatusTypes.Processing: return '処理中';
    case BackgroundStatusTypes.Succeeded: return '正常終了';
    case BackgroundStatusTypes.Failed: return '失敗終了';
    case BackgroundStatusTypes.Canceled: return 'キャンセル';
  }
}
